import { CALL_API } from '../../middleware/api';

/**
 * KR添加
 */
export const KR_ADD_REQUEST = 'KR_ADD_REQUEST';
export const KR_ADD_SUCCESS = 'KR_ADD_SUCCESS';
export const KR_ADD_FAILURE = 'KR_ADD_FAILURE';

/**
 * KR更新
 */
export const KR_UPDATE_REQUEST = 'KR_UPDATE_REQUEST';
export const KR_UPDATE_SUCCESS = 'KR_UPDATE_SUCCESS';
export const KR_UPDATE_FAILURE = 'KR_UPDATE_FAILURE';

/**
 * KR删除
 */
export const KR_DELETE_REQUEST = 'KR_DELETE_REQUEST';
export const KR_DELETE_SUCCESS = 'KR_DELETE_SUCCESS';
export const KR_DELETE_FAILURE = 'KR_DELETE_FAILURE';

export function addKR(params) {
  return {
    [CALL_API]: {
      types: [KR_ADD_REQUEST, KR_ADD_SUCCESS, KR_ADD_FAILURE],
      endpoint: 'okr/kr/add',
      methods: 'POST',
      params
    }
  }
}

export function updateKR(params) {
  return {
    [CALL_API]: {
      types: [KR_UPDATE_REQUEST, KR_UPDATE_SUCCESS, KR_UPDATE_FAILURE],
      endpoint: 'okr/kr/update',
      methods: 'POST',
      params
    }
  }
}

export function deleteKR(params) {
  return {
    [CALL_API]: {
      types: [KR_DELETE_REQUEST, KR_DELETE_SUCCESS, KR_DELETE_FAILURE],
      endpoint: 'okr/kr/delete',
      methods: 'POST',
      params
    }
  }
}


// WEBPACK FOOTER //
// ./src/action/okr_manage/kr.js